import React from "react";
import { Modal, ModalBody, Card } from "react-bootstrap";
 import {Box,Grid,Typography} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import { useSelector } from "react-redux";
import { replaceContentEditableText } from "../../../utils";
import AnswerCard from '../../AnswerCard/AnswerCard';
import { CircularProgress } from "@mui/material";
import "./RecentRatingsModalStyles.css";
import NewAnswerCard from "./NewAnswerCard";
import { CloseButton } from "react-bootstrap";




export default function RecentRatingsModal() {
  const dispatch = useDispatch();
  const { advanceFilterModalToggle,getQuestionResponseData } = bindActionCreators(Actions, dispatch);
  const modalState = useSelector((state) => state.domain);
  const myStat = useSelector((state) => state.myStatsData);
  const onCloseModal = () => {
    getQuestionResponseData('');
    advanceFilterModalToggle({ bool: false, value: "" })
  }
  const hrStyles = {
		border: 'none',
		borderBottom: '1.5px solid',
		borderImage: 'linear-gradient(90deg, #00D1FF 0%, #BD00FF 15.98%, #0075FF 29.15%, #00E0FF 43.18%)',
		borderImageSlice: 1,
		marginTop: '15px',
		marginBottom: '12px'
	};

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '16px 16px 16px 16px',
    fontFamily: 'Inter',
    fontWeight: 300,
    overflowY:'scroll',
    maxHeight:500,
    outline:'none',
    borderRadius:'6px'
};



  return (
    <>
      <Modal
        show={modalState.modalState}
        onHide={()=>onCloseModal()}
        size="lg"
        centered={true}
        backdrop
      >
        <ModalBody className="modalRecentRatingsBody"> 
        {/* <Modal open={modalState.modalState} onClose={()=>onCloseModal()}> */}
          {/* <Box sx={style}> */}
            {/* <Grid container lg={12} xl={12} sm={12} xs={12} md={12} justifyContent='flex-end'>
            <Typography sx={{ display: "flex", alignItems: "center" }} onClick={() => advanceFilterModalToggle({ bool: false, value: "" })} ><CloseButton style={{padding:'8px'}} /></Typography>
            </Grid> */}
          <div className="titleQuestion">
            <h2 style={{
              fontSize: '21px',
              color: 'rgb(42, 54, 74)',
              fontWeight: 400,
            }}>{myStat.questionTextDetails.question}</h2>
            <div><CloseButton style={{padding:'8px'}} onClick={() => advanceFilterModalToggle({ bool: false, value: "" })} /></div>
          </div>
          {
            myStat.isLoading === false && myStat.questionTextDetails.answers && myStat.questionTextDetails.answers.map((data, index) => {
              return (<>
                {/* <AnswerCard question={myStat.questionTextDetails} answer={data} key={index} /> */}
                <NewAnswerCard answer={data} key={index} question={myStat.questionTextDetails} />
                {index !== myStat.questionTextDetails.answers.length -1 && <hr style={hrStyles} /> }
              </>)
            })
          }
        </ModalBody>
        {/* </Box> */}
      </Modal>
    </>
  )
}